<template>
   <div class="edit-participant-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="udpateCloseViewParticipantDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-4 col-lg-4 text-align-right padding-right-0Px">
                  <!-- Picture: -->
                </div>
                <div class="col-md-6 col-lg-6 text-align-left">
                  <!-- <div class="middle cursor-pointer">
                    <div class="text" v-on:click="updateIsCourseImageSelectedFlag($event,false)">Remove</div>
                  </div> -->
                  <img :src="userImageUrlValue" class="img-circle user-img-width-height background-color" id="userImg" @error="assignDefaultImage"/>
                  <img :src="imgediticon" alt="imgedit" height="20" width="20" class="image-zindex-1 cursor-pointer" v-on:click="openFileExplorerWindow"> 
                  <input type="file" id="selectedFile" accept=".jpg, .jpeg, .png" style="display: none;" v-on:change="onFileSelected($event)"/>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  First Name
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="firstNameValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Last Name
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="lastNameValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Email
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="emailIdValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Username
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="usernameValue" disabled>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 User Location
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="locationValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Password
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="passwordValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Self Summary
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="selfSummaryValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  School
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="schoolValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 User Group
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="userGroupValue">
                                <option value=0>None</option>
                                <option value=1>TCS</option>
                                <option value=2>Morgan Stanley</option>
                                <option value=3>Deloitte</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Gender
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="genderValue">
                                <option value=0>Male</option>
                                <option value=1>Female</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                Account Type
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="accountTypeValue">
                                <option value=0>User</option>
                                <option value=1>Group Admin</option>
                                <option value=2>Admin</option>
                                <option value=3>Coach</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px" v-if="parseInt(userObjectToPass.AccountType) === 1">
                  Admin Group
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group" v-if="parseInt(userObjectToPass.AccountType) === 1">
                        <div class="col-sm-12">
													<select class="form-control Padding-right-0px" v-model="selectedGroupAdminId">
														<option value=-1 disabled>Select</option>
														<option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj.GroupId">{{ groupObj.GroupName }}</option>
                      		</select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="col-md-2 col-lg-2 font-size-15px create-lesson-input-text-style text-align-right padding-right-0Px">
                  <!-- Disabled: -->
                  Session Timeout
                </div>
                <div class="col-md-1 col-lg-1 font-size-15px padding-right">
                    <span class="glyphicon glyphicon-plus-sign cursor-pointer" @click="counter($event,'+')"></span>
                    <span class="font-weight-bold font-size-18px">
                       {{userObjectToPass.SessionTimeout}}
                    </span>
                    <span class="glyphicon glyphicon-minus-sign cursor-pointer" @click="counter($event,'-')"></span>
                          <!-- <input type="text" class="form-control" v-model="sessionTimeOutValue"> -->
                </div>
                <div class="col-md-2 col-lg-2 padding-right-2Point9Perc">
                   <select class="form-control" v-model="sessionTimeOutUnitValue">
                      <!-- <option value=-1 disabled>Timeout Unit</option> -->
                      <option value=0>Minute(s)</option>
                      <option value=1>Hour(s)</option>
                      <option value=2>Day(s)</option>
                   </select>
                </div>
                <div class="col-md-2 col-lg-2 font-size-15px create-lesson-input-text-style text-align-right padding-right-0Px">
                  Group
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control Padding-right-0px" v-model="selectedGroupId">
                        <option value=-1 disabled>Select</option>
                        <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj.GroupId">{{ groupObj.GroupName }}</option>
                      </select>
                    </div>
                  </div> 
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 Cohort Name
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="cohortNameValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 font-size-15px create-lesson-input-text-style text-align-right padding-right-0Px">
                  Enable MS Team Notfications
                </div>    
                <div class="col-md-3 col-lg-3 text-align-left">
                    <div class="form-group">
                      <div class="col-sm-12">
                        <div class="checkbox">
                          <label><input type="checkbox" v-model="enableMSTeamsValue"></label>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right" v-if="enableMSTeamsValue">
                  MS Team Email 
                </div>    
                <div class="col-md-3 col-lg-3">
                    <div class="form-group" v-if="enableMSTeamsValue">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="msTeamEmailIdValue">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 font-size-15px create-lesson-input-text-style text-align-right padding-right-0Px">
                  Disable Offline
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                        <div class="checkbox">
                            <label><input type="checkbox" v-model="disableOfflineValue"></label>
                        </div>
                    </div>
                  </div> 
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                Disable Profile Edit
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                        <div class="checkbox">
                            <label><input type="checkbox" v-model="disableProfileEditValue"></label>
                        </div>
                    </div>
                  </div> 
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateParticipant($event)">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div> 
</template>
<script>
import { groupService } from '@/server-util/group-service'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import { participantService } from '@/server-util/participant-service'
import editicon from '../assets/images/profileimageediticon.svg'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
// import { constants } from '@/utils/constants'
import ErrorImage from '../assets/images/usericon2.svg'
export default {
  props: ['userObj'],
  name: 'edit-participant-details',
  created () {
    this.setDefaultValues()
    this.getGroups()
  },
  data: function () {
    return {
      userObjectToPass: {
        UserId: '',
        FirstName: '',
        LastName: '',
        EmailId: '',
        UserName: '',
        Disabled: false,
        DisableOffline: false,
        DisableProfileEdit: false,
        MSTeamEmailId: '',
        EnableMSTeams: false,
        AccountType: -1,
        Gender: -1,
        SelfSummary: '',
        UserLocation: '',
        School: '',
        SessionTimeout: 0,
        SessionTimeoutUnit: 0,
        Group: -1,
        Password: '',
        GroupAdminId: ''
      },
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      imgediticon: editicon,
      sessionTimeOutUpperLimit: 60,
      selectedGroupAdminId: -1,
      selectedGroupId: -1
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    validateEmail: function (mail) {
      /* eslint-disable */
      var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      /* eslint-enable */
      return mailformat.test(mail)
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    udpateCloseViewParticipantDetailOverlay: function (event) {
      // AK: Hide overlay (ParticipantList file)
      this.$emit('closeEditParticipant', false)
    },
    assignDefaultImage: function (event) {
      document.getElementById('userImg').src = ErrorImage
    },
    setDefaultValues: function () {
      this.userObjectToPass.UserId = this.userObj.UserId
      this.userObjectToPass.FirstName = this.userObj.FirstName
      this.userObjectToPass.LastName = this.userObj.LastName
      this.userObjectToPass.UserLocation = this.userObj.Location === 'null' || this.userObj.Location === null ? '' : this.userObj.Location
      this.userObjectToPass.EmailId = this.userObj.EmailId
      this.userObjectToPass.UserName = this.userObj.Username
      this.userObjectToPass.School = this.userObj.School === null || this.userObj.School === 'null' ? '' : this.userObj.School
      this.userObjectToPass.CohortName = this.userObj.CohortName === null || this.userObj.CohortName === 'null' || this.userObj.CohortName === '' ? '' : this.userObj.CohortName
      this.userObjectToPass.SelfSummary = this.userObj.SelfSummary === null || this.userObj.SelfSummary === 'null' ? '' : this.userObj.SelfSummary
      this.userObjectToPass.SessionTimeout = this.userObj.SessionTimeout
      this.userObjectToPass.SessionTimeoutUnit = this.userObj.SessionTimeoutUnit
      this.userObjectToPass.Disabled = this.userObj.Disabled
      this.userObjectToPass.DisableProfileEdit = this.userObj.DisableProfileEdit
      this.userObjectToPass.DisableOffline = this.userObj.DisableOffline
      this.userObjectToPass.Gender = this.userObj.Gender
      this.userObjectToPass.AccountType = this.userObj.AccountType
      this.userObjectToPass.Group = this.userObj.UserGroup
      this.userObjectToPass.GroupAdminId = this.userObj.GroupAdminId === '00000000-0000-0000-0000-000000000000' ? -1 : this.userObj.GroupAdminId
      this.userObjectToPass.GroupId = this.userObj.GroupId === '00000000-0000-0000-0000-000000000000' ? -1 : this.userObj.GroupId
      this.selectedGroupAdminId = this.userObjectToPass.GroupAdminId
      this.selectedGroupId = this.userObj.GroupId === '00000000-0000-0000-0000-000000000000' || this.userObj.GroupId === null ? -1 : this.userObj.GroupId
      this.userObjectToPass.EnableMSTeams = this.userObj.EnableMSTeams !== undefined && this.userObj.EnableMSTeams !== 'undefined' && this.userObj.EnableMSTeams !== null && this.userObj.EnableMSTeams !== 'null' && this.userObj.EnableMSTeams !== '' ? this.userObj.EnableMSTeams : false
      this.userObjectToPass.MSTeamEmailId = this.userObj.EnableMSTeams && this.userObj.MSTeamEmailId !== undefined && this.userObj.MSTeamEmailId !== 'undefined' && this.userObj.MSTeamEmailId !== null && this.userObj.MSTeamEmailId !== 'null' && this.userObj.MSTeamEmailId !== '' && this.userObj.MSTeamEmailId.length > 0 ? this.userObj.MSTeamEmailId : ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.userObjectToPass.FirstName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'First name can\'t be empty.'
        this.userObjectToPass.FirstName = this.userObj.FirstName
        return false
      } else if (this.userObjectToPass.LastName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Last name can\'t be empty.'
        this.userObjectToPass.LastName = this.userObj.LastName
        return false
      } else if (this.userObjectToPass.UserName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Username can\'t be empty.'
        this.userObjectToPass.UserName = this.userObj.Username
        return false
      } else if (this.userObjectToPass.EmailId.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Email address can\'t be empty.'
        this.userObjectToPass.EmailId = this.userObj.EmailId
        return false
      } else if (!this.validateEmail(this.userObjectToPass.EmailId)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid email address provided.'
        return false
      } else if (this.userObjectToPass.Gender === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select the gender.'
        return false
      } else if (parseInt(this.userObjectToPass.AccountType) === 1 && this.selectedGroupAdminId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an admin group.'
        this.userObjectToPass.GroupAdminId = this.userObj.GroupAdminId === null || this.userObj.GroupAdminId === undefined ? -1 : this.userObj.GroupAdminId
        return false
      } else if (this.userObjectToPass.EnableMSTeams && this.userObjectToPass.MSTeamEmailId.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'MS Team Email Id can\'t be empty.'
        this.userObjectToPass.MSTeamEmailId = (this.userObj.EnableMSTeams && this.userObj.MSTeamEmailId !== undefined && this.userObj.MSTeamEmailId !== 'undefined' && this.userObj.MSTeamEmailId !== null && this.userObj.MSTeamEmailId !== 'null' && this.userObj.MSTeamEmailId !== '' && this.userObj.MSTeamEmailId.length > 0) ? this.userObj.MSTeamEmailId : ''
        return false
      } else if (this.userObjectToPass.EnableMSTeams && !this.validateEmail(this.userObjectToPass.MSTeamEmailId)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid MS Team Email Id provided.'
        this.userObjectToPass.MSTeamEmailId = (this.userObj.EnableMSTeams && this.userObj.MSTeamEmailId !== undefined && this.userObj.MSTeamEmailId !== 'undefined' && this.userObj.MSTeamEmailId !== null && this.userObj.MSTeamEmailId !== 'null' && this.userObj.MSTeamEmailId !== '' && this.userObj.MSTeamEmailId.length > 0) ? this.userObj.MSTeamEmailId : ''
        return false
      } else if (this.selectedGroupId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.userObjectToPass.CohortName.length > 0 && (!this.userObjectToPass.CohortName.replace(/\s/g, '').length)) {
        this.userObjectToPass.CohortName = ''
        this.showAlertDialog = true
        this.errorMsg = 'Cohort name can\'t only have empty spaces.'
        return false
      }
      return true
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    onFileSelected: function (event) {
      if (
        !this.checkUserImageExtension(
          document.getElementById('selectedFile').value
        )
      ) {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select .jpg, .jpeg or .png file.'
        event.target.value = ''
        return
      }
      this.isCourseImageSelected = true
      var selectedFile = event.target.files[0]
      var reader = new FileReader()
      var imgtag = document.getElementById('userImg')
      imgtag.title = selectedFile.name
      reader.onload = function (event) {
        imgtag.src = event.target.result
      }
      reader.readAsDataURL(selectedFile)
    },
    openFileExplorerWindow: function () {
      document.getElementById('selectedFile').click()
    },
    checkUserImageExtension: function (fileName) {
      var exts = ['.jpg', '.jpeg', '.png']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    updateParticipant: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var userPicture = document.getElementById('selectedFile').files[0]
        if (userPicture !== undefined) {
          if (
            !this.checkUserImageExtension(
              document.getElementById('selectedFile').value
            )
          ) {
            this.showAlertDialog = true
            this.errorMsg =
              'Please select .jpg, .jpeg or .png file.'
            return
          }
        } else {
          userPicture = null
        }
        // console.log(' Object before Update >>>> ' + JSON.stringify(this.userObjectToPass))
        const formData = new FormData()
        formData.append('UserId', this.userObjectToPass.UserId)
        formData.append('FirstName', this.userObjectToPass.FirstName)
        formData.append('LastName', this.userObjectToPass.LastName)
        formData.append('EmailId', this.userObjectToPass.EmailId)
        formData.append('UserName', this.userObjectToPass.UserName)
        formData.append('Disabled', this.userObjectToPass.Disabled)
        formData.append('DisableOffline', this.userObjectToPass.DisableOffline)
        formData.append('DisableProfileEdit', this.userObjectToPass.DisableProfileEdit)
        formData.append('AccountType', parseInt(this.userObjectToPass.AccountType))
        formData.append('Group', parseInt(this.userObjectToPass.Group))
        formData.append('Gender', parseInt(this.userObjectToPass.Gender))
        formData.append('SelfSummary', this.userObjectToPass.SelfSummary)
        formData.append('UserLocation', this.userObjectToPass.UserLocation)
        formData.append('School', this.userObjectToPass.School)
        formData.append('SessionTimeout', this.userObjectToPass.SessionTimeout)
        formData.append('SessionTimeoutUnit', this.userObjectToPass.SessionTimeoutUnit)
        formData.append('ImageFile', userPicture)
        formData.append('CohortName', this.userObjectToPass.CohortName)
        formData.append('EnableMSTeams', this.userObjectToPass.EnableMSTeams)
        formData.append('MSTeamEmailId', this.userObjectToPass.EnableMSTeams ? this.userObjectToPass.MSTeamEmailId : null)
        if (parseInt(this.userObjectToPass.AccountType) === 1) {
          formData.append('GroupAdminId', this.selectedGroupAdminId)
        }
        formData.append('GroupId', this.selectedGroupId)
        formData.append('Password', this.userObjectToPass.Password)
        var _this = this
        var storeObj = this.$store
        if (formData !== undefined || formData !== '' || formData !== undefined) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          participantService
            .UpdateParticipant(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Hide Spinner
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                  // AK: Hide overlay (ParticipantList file)
                  _this.$emit('closeEditParticipant', false)
                  _this.$emit('refreshList', true)
                } else {
                  // AK: Hide Spinner
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined Update PARTICIPANT OPERATION'
          )
        }
      }
    },
    counter: function (event, selectedOperation) {
      /*
      switch (selectedOperation) {
        case '+':
          if (this.sessionTimeOutUpperLimit !== this.userObjectToPass.SessionTimeout) {
            this.userObjectToPass.SessionTimeout += 1
          }
          break
        case '-':
          if (this.userObjectToPass.SessionTimeout !== 0) {
            this.userObjectToPass.SessionTimeout -= 1
          }
          break
      }
      */
      switch (selectedOperation) {
        case '+':
          this.userObjectToPass.SessionTimeout += 1
          if (this.sessionTimeOutUpperLimit !== this.userObjectToPass.SessionTimeout) {
          } else {
            if (this.userObjectToPass.SessionTimeout === 60 && this.sessionTimeOutUpperLimit === 60) {
              this.userObjectToPass.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Hours)
              this.userObjectToPass.SessionTimeout = 1
              this.sessionTimeOutUpperLimit = 24
            } else if (this.userObjectToPass.SessionTimeout === 24 && this.sessionTimeOutUpperLimit === 24) {
              this.userObjectToPass.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Days)
              this.userObjectToPass.SessionTimeout = 1
              this.sessionTimeOutUpperLimit = 365
            }
          }
          break
        case '-':
          if (this.userObjectToPass.SessionTimeout !== 0) {
            this.userObjectToPass.SessionTimeout -= 1
            if (this.sessionTimeOutUpperLimit !== this.userObjectToPass.SessionTimeout) {
              if (this.userObjectToPass.SessionTimeout === 0 && this.sessionTimeOutUpperLimit === 24) {
                this.userObjectToPass.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Minutes)
                this.userObjectToPass.SessionTimeout = 59
                this.sessionTimeOutUpperLimit = 60
              } else if (this.userObjectToPass.SessionTimeout === 0 && this.sessionTimeOutUpperLimit === 365) {
                this.userObjectToPass.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Hours)
                this.userObjectToPass.SessionTimeout = 23
                this.sessionTimeOutUpperLimit = 24
              }
            }
          }
          break
      }
    }
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    firstNameValue: {
      get: function () {
        return this.userObjectToPass.FirstName
      },
      set: function (newValue) {
        this.userObjectToPass.FirstName = newValue
      }
    },
    lastNameValue: {
      get: function () {
        return this.userObjectToPass.LastName
      },
      set: function (newValue) {
        this.userObjectToPass.LastName = newValue
      }
    },
    locationValue: {
      get: function () {
        return this.userObjectToPass.UserLocation
      },
      set: function (newValue) {
        this.userObjectToPass.UserLocation = newValue
      }
    },
    emailIdValue: {
      get: function () {
        return this.userObjectToPass.EmailId
      },
      set: function (newValue) {
        this.userObjectToPass.EmailId = newValue
      }
    },
    usernameValue: {
      get: function () {
        return this.userObjectToPass.UserName
      },
      set: function (newValue) {
        this.userObjectToPass.UserName = newValue
      }
    },
    schoolValue: {
      get: function () {
        return this.userObjectToPass.School
      },
      set: function (newValue) {
        this.userObjectToPass.School = newValue
      }
    },
    cohortNameValue: {
      get: function () {
        return this.userObjectToPass.CohortName
      },
      set: function (newValue) {
        this.userObjectToPass.CohortName = newValue
      }
    },
    selfSummaryValue: {
      get: function () {
        return this.userObjectToPass.SelfSummary
      },
      set: function (newValue) {
        this.userObjectToPass.SelfSummary = newValue
      }
    },
    passwordValue: {
      get: function () {
        return this.userObjectToPass.Password
      },
      set: function (newValue) {
        this.userObjectToPass.Password = newValue
      }
    },
    sessionTimeOutValue: {
      get: function () {
        return this.userObjectToPass.SessionTimeout
      },
      set: function (newValue) {
        this.userObjectToPass.SessionTimeout = newValue
      }
    },
    sessionTimeOutUnitValue: {
      get: function () {
        return this.userObjectToPass.SessionTimeoutUnit
      },
      set: function (newValue) {
        this.userObjectToPass.SessionTimeout = 0
        switch (parseInt(newValue)) {
          case 0:
            this.sessionTimeOutUpperLimit = 60
            break
          case 1:
            this.sessionTimeOutUpperLimit = 24
            break
          case 2:
            this.sessionTimeOutUpperLimit = 365
            break
        }
        this.userObjectToPass.SessionTimeoutUnit = parseInt(newValue)
      }
    },
    disabledValue: {
      get: function () {
        return this.userObjectToPass.Disabled
      },
      set: function (newValue) {
        this.userObjectToPass.Disabled = newValue
      }
    },
    disableProfileEditValue: {
      get: function () {
        return this.userObjectToPass.DisableProfileEdit
      },
      set: function (newValue) {
        this.userObjectToPass.DisableProfileEdit = newValue
      }
    },
    disableOfflineValue: {
      get: function () {
        return this.userObjectToPass.DisableOffline
      },
      set: function (newValue) {
        this.userObjectToPass.DisableOffline = newValue
      }
    },
    enableMSTeamsValue: {
      get: function () {
        return this.userObjectToPass.EnableMSTeams
      },
      set: function (newValue) {
        this.userObjectToPass.EnableMSTeams = newValue
      }
    },
    msTeamEmailIdValue: {
      get: function () {
        return this.userObjectToPass.MSTeamEmailId
      },
      set: function (newValue) {
        this.userObjectToPass.MSTeamEmailId = newValue
      }
    },
    genderValue: {
      get: function () {
        return this.userObjectToPass.Gender
      },
      set: function (newValue) {
        this.userObjectToPass.Gender = newValue
      }
    },
    accountTypeValue: {
      get: function () {
        return this.userObjectToPass.AccountType
      },
      set: function (newValue) {
        this.userObjectToPass.AccountType = newValue
      }
    },
    userGroupValue: {
      get: function () {
        return this.userObjectToPass.Group
      },
      set: function (newValue) {
        this.userObjectToPass.Group = newValue
      }
    },
    userImageUrlValue: {
      get: function () {
        return server.baseURL() + '/api/UserProfile/Picture?userId=' + this.userObj.UserId
      }
    }
  }
}
</script>

<style scoped>
.img-circle {
    border-radius: 75px;
}
.background-color {
  background-color: #d4d4d4;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
.image-zindex-1 {
    position: absolute;
    left: 33px;
    top: 119px;
    z-index: 1;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.padding-right {
  padding-right: 0px !important;
}
.margin-auto{
  margin: auto !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.user-img-width-height {
  width: 150px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold !important;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: black;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  opacity: 0.6;
}
.cursor-pointer {
  cursor: pointer;
}
.font-weight-bold {
  font-weight: bold;
}
.glyphicon {
    font-size: 15px;
}
.font-size-18px {
  font-size: 18px;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.vcenter {
    display: inline-block;
    vertical-align: middle;
    float: none;
}
.padding-right-2Point9Perc{
  padding-right:2.9% !important; 
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateParticipantDetailsOverlay.vue